jQuery('#accreditationsSlider').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 6,
    centerMode: false,
    arrows: false,
    autoplay: false,
    prevArrow: jQuery(".arrows.mobile .accreditations-slider-prev"),
    nextArrow: jQuery(".arrows.mobile .accreditations-slider-next"),
    rows: 0,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
            }
        },
        {
            breakpoint: 550,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
            }
        }
    ]
});